module.exports = __webpack_public_path__ + "img/honda_thumbnail.a4a8e9b7.png";